'use client';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { PropsWithClassname } from '@/app/types';

import Notification, { NotificationType } from '@/app/components/Notification/Notification';

interface SubprojectGoodHabitNotification extends PropsWithClassname {}

const SubprojectGoodHabitNotification = ({ className }: SubprojectGoodHabitNotification) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(className, 'px-[24px] lg:px-0')}>
      <Notification type={NotificationType.WARNING} className="w-full default-page-max-width mx-auto shadow-none">
        {t('components.SubprojectGoodHabitNotification.text')}
      </Notification>
    </div>
  );
};

export default SubprojectGoodHabitNotification;
